import { render, staticRenderFns } from "./receipt_image_view.vue?vue&type=template&id=c638ebda&scoped=true"
import script from "./receipt_image_view.vue?vue&type=script&lang=js"
export * from "./receipt_image_view.vue?vue&type=script&lang=js"
import style0 from "./receipt_image_view.vue?vue&type=style&index=0&id=c638ebda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c638ebda",
  null
  
)

export default component.exports